import { InputSignal, Signal } from '@angular/core';

export type WithQueryParams<T extends string> = Record<T, Signal<string | undefined>>;
export type WithRouteParams<T extends string> = Record<T, InputSignal<string | undefined>>;

export const DetailsRouteParams = {
  USER_FRIENDLY_ID: 'userFriendlyId',
} as const;

export type DetailsRouteParams = (typeof DetailsRouteParams)[keyof typeof DetailsRouteParams];

export const ActionCreateQueryParams = {
  THEME_ID: 'themeId',
} as const;

export type ActionCreateQueryParams = (typeof ActionCreateQueryParams)[keyof typeof ActionCreateQueryParams];

export const NotFoundQueryParams = {
  URL: 'url',
} as const;

export type NotFoundQueryParams = (typeof NotFoundQueryParams)[keyof typeof NotFoundQueryParams];

export const FoldersQueryParams = {
  STATUS: 'status',
} as const;

export type FoldersQueryParams = (typeof FoldersQueryParams)[keyof typeof FoldersQueryParams];
